define('views/conversations/Podio.Views.Conversations.UserEvent',['require','translate','lib/backbone/Backbone.PodioView','root/audio_video/Podio.UI.AudioVideo.GTMFree','jst!conversations/_participant_add','jst!conversations/_participant_leave','jst!conversations/_live_event','jst!conversations/_subject_change'],function(require) {

  var t = require('translate');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var AudioVideoGTMFree = require('root/audio_video/Podio.UI.AudioVideo.GTMFree');
  var jstParticipantAdd = require('jst!conversations/_participant_add');
  var jstParticipantLeave = require('jst!conversations/_participant_leave');
  var jstLiveEvent = require('jst!conversations/_live_event');
  var jstSubjectChange = require('jst!conversations/_subject_change');

  return ViewPodioBase.extend({
    tagName: 'li',
    className: 'user-event',

    render: function() {
      switch (this.model.get('action')) {
      case 'participant_add':
        this.elm.html(this.getTemplate(jstParticipantAdd, {
          conversationEvent: this.model,
          translations: {
            participant_add: t('{0} was added to the conversation #conversations').format(this.model.get('data').name)
          }
        }));
        break;
      case 'participant_leave':
        this.elm.html(this.getTemplate(jstParticipantLeave, {
          conversationEvent: this.model,
          translations: {
            participant_leave: t('{0} left the conversation #conversations').format(this.model.get('created_by').get('name'))
          }
        }));
        break;
      case 'live_start':
        var data = this.model.get('data');

        var providers = {
            gtm_free: AudioVideoGTMFree,
        };

        var provider = providers[data.provider];

        var url = provider && data.status === 'started'
          ? provider.getUrl(data.provider_id)
          : null;

        this.elm.html(this.getTemplate(jstLiveEvent, {
          conversationEvent: this.model,
          icon: 'icon-phone',
          url: url,
          translations: {
            text: t('{0} has initiated a call #omega').format(this.model.get('created_by').get('name')),
            join: t('Join #omega')
          }
        }));
        break;
      case 'live_end':
        this.elm.html(this.getTemplate(jstLiveEvent, {
          conversationEvent: this.model,
          icon: 'icon-16-phone-hangup',
          url: null,
          translations: {
            text: t('{0} has ended a call #omega').format(this.model.get('created_by').get('name'))
          }
        }));
        break;
      case 'live_accept':
        this.elm.html(this.getTemplate(jstLiveEvent, {
          conversationEvent: this.model,
          icon: 'icon-phone',
          url: null,
          translations: {
            text: t('{0} has accepted the call #omega').format(this.model.get('created_by').get('name'))
          }
        }));
        break;
      case 'live_decline':
        this.elm.html(this.getTemplate(jstLiveEvent, {
          conversationEvent: this.model,
          icon: 'icon-16-phone-hangup',
          url: null,
          translations: {
            text: t('{0} has declined call #omega').format(this.model.get('created_by').get('name'))
          }
        }));
        break;
      case 'subject_change':
        this.elm.html(this.getTemplate(jstSubjectChange, {
          conversationEvent: this.model,
          translations: {
            subject_change: t('{0} changed the subject #conversations').format(this.model.get('created_by').get('name'))
          }
        }));
        break;
      }

      return this;
    }

  });

});

